import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_4 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_5 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION ", -1)
const _hoisted_7 = { class: "tw-px-4" }
const _hoisted_8 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_9 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/2 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY BUDGET PAYMENT ", -1)
const _hoisted_11 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_14 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_16 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_19 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT ", -1)
const _hoisted_21 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_22 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_23 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_24 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE ", -1)
const _hoisted_26 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_29 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS ", -1)
const _hoisted_31 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_34 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT ", -1)
const _hoisted_36 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_39 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PAYMENT ", -1)
const _hoisted_41 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_44 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM ", -1)
const _hoisted_46 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_49 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_51 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_54 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES ", -1)
const _hoisted_56 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_59 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX ", -1)
const _hoisted_61 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_64 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE ", -1)
const _hoisted_66 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_69 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION ", -1)
const _hoisted_71 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_74 = { class: "tw-flex tw-justify-center" }
const _hoisted_75 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_76 = { class: "tw-flex tw-justify-end tw-gap-[50px]" }
const _hoisted_77 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " ESTIMATE MORTGAGE ", -1)
const _hoisted_79 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " ESTIMATES TOTAL MONTHLY PAYMENT ", -1)
const _hoisted_81 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import axios from 'axios';
import { ref, computed } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";

//COMPONENTS
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";

import { useToast } from "@/composables/useToast";
import SheetBudget from '../economicSheet/SheetBudget.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Budget',
  setup(__props) {

const toast = useToast();

//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const userSession = ref(null)
const selectedMLO = ref(null)
const selectedCompanyTitle = ref({ data: null })
const selectedInspector = ref({ data: null })
const customer = ref({
  name: '',
  phone: '',
  email: ''
})
const financialInformation = ref({
  pmi: 0,
  mortgage: 0,
  propertyPrice: 0,
  monthlyBudget: 0,
  downPayment: 0,
  propertyPriceQuantity: 0,
  monthlyPayment: 0,
  propertyTaxes: 0,
  stateTaxes: 0,
  propertyInsurance: 0,
  association: 0,
  totalMonthly: 0
})

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

// GET TAXES FROM REALTOR FORM
const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    if (response.data.averageTaxesAndInsurance) {
      financialInformation.value.propertyTaxes = response.data.averageTaxesAndInsurance.property_taxes
      financialInformation.value.stateTaxes = response.data.averageTaxesAndInsurance.federal_taxes
      financialInformation.value.propertyInsurance = response.data.averageTaxesAndInsurance.property_insurance
    }
  }
  loading.value = false;
};
getRealtorForm();

const pmi = computed(() => {
  let result = 0
  if ( selectedMLO.value !== null) {
    const percentage = financialInformation.value.downPayment / financialInformation.value.propertyPrice
    const percentageTwo = parseFloat(percentage.toFixed(2))
    const valueMinimunDown = selectedMLO.value.minimumDownPayment / 100
    if (percentageTwo < parseFloat(valueMinimunDown.toFixed(2))) {
      result = ((selectedMLO.value.PMI / 100) * loanAmount.value) / 12
    } 
  }
  return result !== 0 ? parseFloat((result).toFixed(2)) : result
})

const sortOutRatio = computed(() => {
  let interest_rate = 0;
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
  }
  return Math.pow(1 + ((interest_rate / 12) / 100), years) * ((interest_rate / 12) / 100);
})

const sortOutRatio2 = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    result = Math.pow(1 + (interest_rate / 12) / 100, years) - 1
  }
  return result
})

const sortOutFactor = computed(() => {
  let result = 0
  if (sortOutRatio.value !== 0 && sortOutRatio2.value !== 0) {
    result = sortOutRatio.value / sortOutRatio2.value
  }
  return result
})


const loanAmount = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = financialInformation.value.propertyPrice - financialInformation.value.downPayment
  }
  return parseFloat(result.toFixed(2))
})

const PriceDownpayment = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0 && selectedMLO.value !== null ) {
    result = financialInformation.value.propertyPrice * (selectedMLO.value.minimumDownPayment /100)
  }
  return parseFloat(result.toFixed(0))
})

const propertyTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const federalTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.stateTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const propertyInsurance = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyInsurance / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const monthlyPayment = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    const interestRateRatio = (interest_rate / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest
  }
  return parseFloat(result.toFixed(2))
})

const totalMonthly = computed(() => {
  let result = 0
  if (financialInformation.value.association !== null) {
    result = monthlyPayment.value + propertyTaxes.value + federalTaxes.value + propertyInsurance.value + financialInformation.value.association + pmi.value
  }
  return parseFloat(result.toFixed(2))
})

const calculateField = async (property) => {
  if (property == "taxes") {
    if (
      financialInformation.value.propertyPrice &&
      selectedMLO.value !== null
    ) {
      financialInformation.value.propertyTaxes =
        (financialInformation.value.propertyTaxes *
          financialInformation.value.propertyPrice) /
        12 /
        100;
      financialInformation.value.stateTaxes =
        (financialInformation.value.stateTaxes *
          financialInformation.value.propertyPrice) /
        12 /
        100;
      financialInformation.value.propertyInsurance =
        (financialInformation.value.propertyInsurance *
          financialInformation.value.propertyPrice) /
        12 /
        100;
    }
  }

  if (property == "estimatemortgage") {
    if (
      financialInformation.value.propertyPrice &&
      financialInformation.value.downPayment
    ) {
      financialInformation.value.mortgage =
        financialInformation.value.propertyPrice -
        financialInformation.value.downPayment;
    }
  }

  if (property == "estimatemortgage" || property == "monthlypayment") {
    let params = {
      propertyPrice: financialInformation.value.propertyPrice,
      propertyDownPayment: financialInformation.value.downPayment,
      propertyMortgage: financialInformation.value.mortgage,
    };

    let r = await submitFormula();

    if (r && r.propertyMonthlyPayment) {
      financialInformation.value.monthlyPayment = r.propertyMonthlyPayment;
    }
  }
}

const submitScenario = async () => {
  loading.value = true;
  const response = await axios(`${url}realtor-budget`, {
    method: "POST",
    data: {
      realtorBudget: [{
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "BUDGET",
        monthlyBudget: financialInformation.value.monthlyBudget,
        propertyPrice: financialInformation.value.propertyPrice,
        downPayment: financialInformation.value.downPayment,
        interestRate: selectedMLO.value.interestRate,
        year: selectedMLO.value.filters.year,
        loanAmount: loanAmount.value,
        monthlyPayment: monthlyPayment.value,
        program: selectedMLO.value.filters.program,
        pmi: pmi.value,
        propertyTaxes: propertyTaxes.value,
        federalTaxes: federalTaxes.value,
        propertyInsurance: propertyInsurance.value,
        association: financialInformation.value.association,
        totalMonthly: totalMonthly.value,
        client_name: customer.value.name,
        client_email: customer.value.email
      }],
      customer: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "BUDGET",
        name: customer.value.name,
        phone: customer.value.phone,
        email: customer.value.email
      },
      mloSelected: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "BUDGET",
        name: selectedMLO.value.realtorMLOData.name,
        lastname: selectedMLO.value.realtorMLOData.lastname,
        phone: selectedMLO.value.realtorMLOData.phone,
        email: selectedMLO.value.realtorMLOData.email,
        program: selectedMLO.value.filters.program,
        interestRate: selectedMLO.value.interestRate,
        minimumDownPayment: selectedMLO.value.minimumDownPayment,
        pmi: selectedMLO.value.PMI,
        backEndRatio: selectedMLO.value.backEndRatio,
        maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
        client_name: customer.value.name,
        client_email: customer.value.email
      },

    }

  });

  if (!response.data.error) {
    loading.value = false;
    await toast.success(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } else {
    loading.value = false;
    await toast.error(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }
}



const submitFormula = async () => {
  const FInformation: any = {
    monthlyBudget: financialInformation.value.monthlyBudget,
    downPayment: financialInformation.value.downPayment,
    propertyPrice: financialInformation.value.propertyPrice
      ? financialInformation.value.propertyPrice
      : 0,
    propertyPriceQuantity: financialInformation.value.propertyPriceQuantity,
    interes_rate: selectedMLO.value !== null
      ? selectedMLO.value.interestRate
      : 0,
    selectedYears: selectedMLO.value.filters.year,
    mortgage: financialInformation.value.mortgage,
    monthlyPayment: financialInformation.value.monthlyPayment
      ? financialInformation.value.monthlyPayment
      : 0,
    selectedProgram: selectedMLO.value.filters.program,
    pmi: pmi,
    propertyTaxes: financialInformation.value.propertyTaxes
      ? financialInformation.value.propertyTaxes
      : 0,
    stateTaxes: financialInformation.value.stateTaxes
      ? financialInformation.value.stateTaxes
      : 0,
    propertyInsurance: financialInformation.value.propertyInsurance
      ? financialInformation.value.propertyInsurance
      : 0,
    association: financialInformation.value.association
      ? financialInformation.value.association
      : 0,
    totalMonthly: financialInformation.value.totalMonthly
      ? financialInformation.value.totalMonthly
      : 0,
  };

  const suma =
    FInformation.monthlyBudget +
    FInformation.downPayment +
    FInformation.propertyPrice +
    FInformation.propertyPriceQuantity +
    FInformation.mortgage +
    FInformation.monthlyPayment +
    FInformation.pmi +
    FInformation.propertyTaxes +
    FInformation.stateTaxes +
    FInformation.propertyInsurance +
    FInformation.association +
    FInformation.totalMonthly;

  financialInformation.value.totalMonthly = suma;

  return {
    propertyMonthlyPayment: suma,
  };
}

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''BUDGET''",
      helpVideo: "https://www.realtortools.org/media/Video-Budget.mp4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(ResidentialView, { header: false })
      ]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SheetBudget),
        _createVNode(FindA, {
          userSession: userSession.value,
          usingCompanyTitle: selectedCompanyTitle.value,
          usingInspector: selectedInspector.value
        }, null, 8, ["userSession", "usingCompanyTitle", "usingInspector"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MLO, {
            title: "BUDGET",
            userSession: userSession.value,
            usingMLO: selectedMLO.value,
            "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
            customer: customer.value
          }, null, 8, ["userSession", "usingMLO", "customer"]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_unref(VueNumberFormat), {
                        value: financialInformation.value.monthlyBudget,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((financialInformation.value.monthlyBudget) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: false,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _createElementVNode("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "propertyPriceBudget",
                        class: "tw-w-full",
                        value: financialInformation.value.propertyPrice,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((financialInformation.value.propertyPrice) = $event)),
                        options: {
                              precision: 0,
                              prefix: '$ ',
                              thousand: ',',
                              acceptNegative: true,
                              isInteger: false,
                              decimal: '.',
                            }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _createElementVNode("tr", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("td", _hoisted_21, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "downPaymentBudget",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (calculateField('estimatemortgage'))),
                        value: financialInformation.value.downPayment,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((financialInformation.value.downPayment) = $event)),
                        options: {
                          precision: 0,
                          prefix: '$ ',
                          thousand: ',',
                          acceptNegative: false,
                          isInteger: true,
                          decimal: '.',
                        }
                      }, null, 8, ["value", "options"])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "downPaymentBudget",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (calculateField('estimatemortgage'))),
                        value: PriceDownpayment.value,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((PriceDownpayment).value = $event)),
                        options: {
                          precision: 0,
                          prefix: '$ ',
                          thousand: ',',
                          acceptNegative: false,
                          isInteger: true,
                          decimal: '.',
                        }
                      }, null, 8, ["value", "options"])
                    ]),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.minimumDownPayment
                          : "") + " % ", 1)
                  ]),
                  _createElementVNode("tr", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("td", _hoisted_26, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.interestRate
                          : "") + " % ", 1),
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _createElementVNode("tr", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("td", _hoisted_31, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.filters.year
                          : ""), 1),
                    _hoisted_32,
                    _hoisted_33
                  ]),
                  _createElementVNode("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("td", _hoisted_36, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "estimatemortgage",
                        readonly: "",
                        value: loanAmount.value,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((loanAmount).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  _createElementVNode("tr", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("td", _hoisted_41, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: monthlyPayment.value,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((monthlyPayment).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_42,
                    _hoisted_43
                  ]),
                  _createElementVNode("tr", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("td", _hoisted_46, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.filters.program
                          : ""), 1),
                    _hoisted_47,
                    _hoisted_48
                  ]),
                  _createElementVNode("tr", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("td", _hoisted_51, " $ " + _toDisplayString(pmi.value !== null ? Math.round(pmi.value).toLocaleString() : ""), 1),
                    _hoisted_52,
                    _hoisted_53
                  ]),
                  _createElementVNode("tr", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("td", _hoisted_56, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: propertyTaxes.value,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((propertyTaxes).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_57,
                    _hoisted_58
                  ]),
                  _createElementVNode("tr", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("td", _hoisted_61, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: federalTaxes.value,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((federalTaxes).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_62,
                    _hoisted_63
                  ]),
                  _createElementVNode("tr", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("td", _hoisted_66, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: propertyInsurance.value,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((propertyInsurance).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_67,
                    _hoisted_68
                  ]),
                  _createElementVNode("tr", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("td", _hoisted_71, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "association",
                        value: financialInformation.value.association,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((financialInformation.value.association) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: false,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_72,
                    _hoisted_73
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createVNode(_unref(VueNumberFormat), {
                    id: "association",
                    value: loanAmount.value,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((loanAmount).value = $event)),
                    options: {
                    precision: 0,
                    prefix: '$ ',
                    thousand: ',',
                    acceptNegative: false,
                    isInteger: false,
                    decimal: '.',
                  },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createVNode(_unref(VueNumberFormat), {
                    id: "association",
                    value: totalMonthly.value,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((totalMonthly).value = $event)),
                    options: {
                    precision: 0,
                    prefix: '$ ',
                    thousand: ',',
                    acceptNegative: false,
                    isInteger: false,
                    decimal: '.',
                  },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("button", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (submitScenario())),
              class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, " SAVE & REGISTER ")
          ])
        ])
      ])
    ])
  ]))
}
}

})